import axios from "axios";
import {GET_PIN_VALIDATION_REQUEST, GET_PIN_VALIDATION_RESPONSE_SUCCESS, GET_PIN_VALIDATION_RESPONSE_FAIL} from "./pinValidationTypes";

export const pinValidationRequestAction = () => {
    return {
        type: GET_PIN_VALIDATION_REQUEST
    }
}

export const pinValidationAction = (pinValidationData) => {
    return {
        type: GET_PIN_VALIDATION_RESPONSE_SUCCESS,
        payload: pinValidationData
    }
}
export const pinValidationFail = (error) => {
    return {
        type: GET_PIN_VALIDATION_RESPONSE_FAIL,
        payload: error
    }
}

export const validatePin = (pin) => {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch(pinValidationAction(success.data))
            return success;
        }
        function onError(error) {
            dispatch(pinValidationFail(error.data))
            return error;
        }
        try {
            dispatch(pinValidationRequestAction())
            const success = await axios.get(process.env.REACT_APP_CUT_REG_BASE_URL + "/pinValidation/" + pin);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }

    }
}
